export default __webpack_public_path__ + "static/media/Ballroll_00085.76b676bf.png";